import { BankAccountListPage } from '@/features/bank-account/pages/BankAccountListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/bank-account/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["bank_account.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BankAccountListPage,
})
